import { Container, NotFoundContainer, TableContainer, NotFoundWrapper, NotFoundIcon } from "./Components";
import TableHeaderCol from "./TableHeaderCol";
import TableRow from "./TableRow";
import Pagination from "./Pagination";
import { useDataTable } from "../../hooks/useDataTable";
import TableCol from "./TableCol";
import { DataTableLoading } from "./DataTableLoading";
import { ColumnData } from "./ColumnData";
import { ColumnSort } from "./ColumnSort";
import { TableFilters } from "./TableFilters";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInbox, faSearch } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from "react-i18next";

export default function DataTableWrapper({customRender}){
    const {t} = useTranslation();
    const context = useDataTable();
    const {columns, isLoading, filterConfig, data, actions} = context;
    let total = {};
    let lastRow = null;
    return (
        <Container>
            <TableFilters />
            {isLoading?<DataTableLoading />:null}
            {!isLoading && (!data || data.length === 0) && Object.keys(filterConfig).length == 0 &&(
                <NotFoundContainer>
                    <NotFoundWrapper>
                        <NotFoundIcon><FontAwesomeIcon icon={faInbox} /></NotFoundIcon>
                        <h3>{t("No data to display")}</h3>
                        <p>{t("It looks like there's no data available yet. Try adding some new items.")}</p>
                    </NotFoundWrapper>
                </NotFoundContainer>
            )}
            {!isLoading && (!data || data.length === 0) && Object.keys(filterConfig).length > 0&&(
                <>
                    <NotFoundContainer>
                        <NotFoundWrapper>
                            <NotFoundIcon><FontAwesomeIcon icon={faSearch} /></NotFoundIcon>
                            <h3>{t("Nothing matched your search")}</h3>
                            <p>{t("We couldn’t find any results. To improve your search, adjust or apply more relevant filters.")}</p>
                        </NotFoundWrapper>
                    </NotFoundContainer>
                </>
                
            )}
            {data && data.length > 0 && (
                <>
                    <TableContainer cellPadding={0}>
                        <thead>
                            <TableRow>
                                {columns.map((col) => {
                                    if(col?.hidden) return;
                                    return (
                                        <TableHeaderCol key={col.key} onClick={() => console.log(col.key)}>
                                            {col.label}
                                            <ColumnSort col={col} />
                                        </TableHeaderCol>
                                    )
                                })}
                                {actions && typeof actions === "function" && (
                                    <TableHeaderCol />
                                )}
                            </TableRow>
                        </thead>
                        <tbody>
                            {data && data.length > 0 && data.map((row, index) => {
                                if(customRender) return customRender(row, index);
                                lastRow = row;
                                return (
                                    <>
                                        <TableRow>
                                            {columns.map((col) => {
                                                if(col?.hidden) return;
                                                if(col?.sum){
                                                    if(!total?.[col.key]){
                                                        total[col.key] = 0;
                                                    }
                                                    total[col.key] += parseFloat(row[col.key]) 
                                                }
                                                return (
                                                    <TableCol>
                                                        <div className="mobile">
                                                            {col.label}
                                                            <ColumnSort col={col} />
                                                        </div>
                                                        <span>
                                                            <ColumnData row={row} column={col} index={index}/>
                                                        </span>
                                                    </TableCol>
                                                )
                                            })}
                                            {actions && typeof actions === "function" && (
                                                <TableCol>
                                                    {actions(row, context)}
                                                </TableCol>
                                            )}
                                        </TableRow>
                                    </>   
                                );
                                
                            })}
                            {Object.keys(total).length > 0 && (
                                <TableRow>
                                    {columns.map((col) => {
                                        if(col?.hidden) return;
                                        if(!total.hasOwnProperty(col.key)) return <TableCol />
                                        return (
                                            <TableCol>
                                                {col.sum(total[col.key], lastRow)}
                                            </TableCol>
                                        )
                                    })}
                                    {actions && typeof actions === "function" && (
                                        <TableCol />
                                    )}
                                </TableRow>
                            )}
                        </tbody>
                    </TableContainer>
                    <Pagination />
                </>
            )}
            
        </Container>
    )
}